module.exports = __webpack_public_path__ + "static/media/card.8ed7ea09.svg";